<template>
  <div>
    <v-app-bar color="transparent" app>
      <!-- Row for Left-Aligned Items -->
      <v-row align="center" class="ma-0 pa-0">
        <!-- Logo -->
        <v-col cols="auto" class="pa-0">
          <v-img
            src="Lo.Green.2_transparent.ico"
            alt="Logo"
            class="navbar-logo"
          ></v-img>
        </v-col>

        <!-- Title -->
        <v-col cols="auto" class="pa-0">
          <v-toolbar-title>
            <span
              style="cursor:pointer;"
              @click="goHome"
              class="text-teal font-weight-bold"
            >
              {{ $t('navbar.title') }}
            </span>
          </v-toolbar-title>
        </v-col>
      </v-row>

      <!-- Spacer -->
      <v-spacer></v-spacer>

      <!-- Language Switch Menu -->
      <v-menu color="teal">
        <template #activator="{ props }">
          <v-btn icon v-bind="props">
            <v-icon color="teal">mdi-earth</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="changeLang('en')">
            <v-list-item-title>EN</v-list-item-title>
          </v-list-item>
          <v-list-item @click="changeLang('ar')">
            <v-list-item-title>AR</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- Navigation Drawer Toggle -->
      <v-app-bar-nav-icon
        variant="text"
        @click.stop="drawer = !drawer"
        color="teal"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <!-- Navigation Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      color="transparent"
      location="end"
    >
      <v-list class="drawer-list" nav>
        <v-list-item @click="goHome" class="drawer-list-item">
          <v-icon class="drawer-icon">mdi-home</v-icon>
          <v-list-item-title class="drawer-title">
            {{ $t('navbar.home') }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="goBookNow" class="drawer-list-item">
          <v-icon class="drawer-icon">mdi-calendar</v-icon>
          <v-list-item-title class="drawer-title">
            {{ $t('navbar.bookNow') }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="goDetails" class="drawer-list-item">
          <v-icon class="drawer-icon">mdi-phone</v-icon>
          <v-list-item-title class="drawer-title">
            {{ $t('navbar.contact') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false
    }
  },
  methods: {
    changeLang(locale) {
      this.$i18n.locale = locale
      // Save to local storage to persist the choice
      localStorage.setItem('user-locale', locale)
    },
    goHome() {
      this.$router.push('/')
      this.drawer = false
    },
    goBookNow() {
      this.$router.push('/book')
      this.drawer = false
    },
    goDetails() {
      this.$router.push('/contactus')
      this.drawer = false
    }
  },
  mounted() {
    // If locale is stored in localStorage, set it on mount
    const savedLocale = localStorage.getItem('user-locale')
    if (savedLocale) {
      this.$i18n.locale = savedLocale
    }
  }
}
</script>

<style scoped>
.text-teal {
  color: #008080; /* Teal color */
}
.font-weight-bold {
  font-weight: bold;
}
.navbar-logo {
  width: 70px;
  height: 70px;
  margin-right: 10px; /* Adjust space between logo and title */
}

/* Styling the drawer list to center items horizontally */
.drawer-list {
  display: flex;
  flex-direction: column;
  align-items: center; /* Centers items horizontally */
  padding-top: 20px; /* Optional: Add top padding */
}

/* Styling individual list items */
.drawer-list-item {
  display: flex;
  align-items: center; /* Vertically centers icon and text within the list item */
  justify-content: center; /* Horizontally centers content within the list item */
  margin-bottom: 2000px; /* Adds vertical gap between items */
  width: 100%; /* Make list items take full width for better centering */
}

/* Increase icon size */
.drawer-icon {
  font-size: 50px; /* Increased icon size */
  margin-right: 12px; 
  color: teal;
}

/* Increase text size */
.drawer-title {
  font-size: 60px; /* Increased text size */
  color: white; /* Ensures text is visible against the transparent background */
}

/* Optional: Adjust the list item hover effect */
.drawer-list-item:hover {
  background-color: rgba(0, 128, 128, 0.1); /* Light teal hover effect */
  border-radius: 8px;
}

/* Responsive Adjustments */
@media (max-width: 600px) {
  .drawer-icon {
    font-size: 28px;
    margin-right: 10px;
  }
  .drawer-title {
    font-size: 18px;
  }
  .drawer-list-item {
    margin-bottom: 16px;
  }
}

@media (min-width: 601px) {
  .drawer-icon {
    font-size: 32px;
    margin-right: 12px;
  }
  .drawer-title {
    font-size: 20px;
  }
  .drawer-list-item {
    margin-bottom: 20px;
  }
}
</style>
